import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";
import { GenerateFileOptions } from "../IGenerateFileOptions";

interface IFileTypeDocument extends IExportableFile {
    DocumentId: string;
}

class FileTypeDocument extends ExportableFile implements IFileTypeDocument {
    public canGenerateFileXcom: boolean = true;

    public DocumentId: string;

    constructor(fields: IFileTypeDocument) {
        super(FileType.DOCUMENT);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.DocumentId; }

    public getCleanCopy(): FileTypeDocument {
        let copyConstructor: IFileTypeDocument = {
            DocumentId: this.DocumentId,
            date: this.date,
            description: this.description
        };

        return new FileTypeDocument(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected async generateFileIfNeededXcom(includeOverlays: boolean): Promise<IExportableFileLoaded> {
        return await this.generateFileIfNeeded({ includeOverlays: includeOverlays, isExternal: true });
    }

    protected generateFileIfNeeded(generateFileOption: GenerateFileOptions): Promise<IExportableFileLoaded> {
        const { isExternal } = generateFileOption;
        const fetchUrl =
            isExternal
                ? FileSelectionHelper.getFetchUrlXcom(this.clientTag, this.claimId, this.DocumentId, this.fileType, { noCache: true })
                : FileSelectionHelper.getFetchUrl(this.DocumentId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }

    /**
     * Get an exportable document's description
     * @param documentSubject
     * @param originalFileName
     * @param documentSubClass
     * @returns
     */
    public static getDocumentFileTypeDescription(documentSubject: string, originalFileName: string, documentSubClass: string = ""): string {
        if (documentSubject?.trim()) {
            return `${documentSubClass} - ${documentSubject.trim()}`;
        }

        return `${documentSubClass} - ${originalFileName}`;
    }
}

export { FileTypeDocument };
